<template lang="html">

  <div class="blog--view blog">
    <h1 class="title title-52">AJUSA blog</h1>

    <intro></intro>

    <section class="cat-blog">

      <div class="pad-sec">
        <div class="container flex wrap justify-between">
         <div class="col-20" v-for="(cat, key, i) in $t('blog.categorias_nombres')">
          <router-link :to="$t('enlaces.blog_categoria')+'/'+key" :data-value="'cat-blog'+(i+1)">
            <img class="img" :src="images[i]" :alt="$t('blog.alt_images.'+key)">
          </router-link>
          <h4  class="tit-cat">{{cat}}</h4>
        </div>
      </div>
    </div>
  </section>


  <template v-if="!!destacados">

    <destacado-el v-for="(e, key) in destacados" :key="key" :data="e"></destacado-el>

  </template>

  <section class="destacados pad-sec">
    <div class="container">
      <h2 class="title title-36">{{$t('blog.ultimas')}}</h2>
      <div class="flex wrap justify-around">
       <template v-if="!!noticias">
        <noticia-el v-for="(e, key) in showPrimeras" :data="e" :key="key"></noticia-el>
        
      </template>
      </div>
    
  </div>
  <div class="btn-leer">
    <span class="btn btn-dark" v-if="contador < noticias.length" v-on:click="showMore">{{$t('genericos.leer_mas')}}</span>
  </div>
</section>

</div>

</template>

<script lang="js">

  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import { mapGetters } from 'vuex'

  Vue.use(VueAxios, axios);

  import Noticia_el from '@/components/parts/noticia-el';
  import Intro from '@/components/view-parts/intros/blog'

  import Destacado_el from '@/components/parts/destacado-blog-el';



  export default  {
    name: 'blog',
    props: [],
    created() {
      this.getData();
        document.oncontextmenu = function(){return false;}
    },
    data() {
      return {
        images: {
          0: '/static/img/blog/blog-ferias.webp',
          1: '/static/img/blog/blog-productos.webp',
          2: "/static/img/blog/cat-blog3.webp",
          3: "/static/img/blog/cat-blog4.webp",
        },
        noticias : '',
        contador : 6
      }
    },
    computed: {
      ...mapGetters({
        lang: 'getLanguage',
      }),
      destacados : function (){
        let posts;
        if(!!this.noticias){
          posts = this.noticias.filter(e => e.destacado);
        }
        return posts;
      },
      showPrimeras: function () {
        return this.noticias.slice(0, this.contador)
      }
    },
    watch : {
      'lang' (){
        this.getData();
      }
    },
    methods : {
      getData (){
        axios.get(`blog?lang=${this.lang}`)
        .then(response => {
          this.noticias = response.data.noticias
        })
        .catch(error => console.log(error));
      },
      showMore(){
        return this.contador = this.contador + 6
        
      }
      
    },
    components: {
      'intro' : Intro,
      'noticia-el' : Noticia_el,
      'destacado-el' : Destacado_el
    }
  }
</script>

<style scoped>
.blog {

}
</style>



// WEBPACK FOOTER //
// src/components/views/blog.vue